(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3207],{

/***/ 51942:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service-plans",
      function () {
        return __webpack_require__(61503);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/Breadcrumbs.js + 2 modules
var Breadcrumbs = __webpack_require__(7885);
// EXTERNAL MODULE: ./components/shopFeatures/wizard/constants.ts
var constants = __webpack_require__(45053);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(90387);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./reusable/icons/BreadCrumbsIcon.tsx

var SvgComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "4",
        height: "8",
        viewBox: "0 0 4 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.5 7L0.5 4L3.5 1",
            stroke: "#D5D5D5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var BreadCrumbsIcon = (SvgComponent);

;// CONCATENATED MODULE: ./common/BreadCrumbsData.tsx
var BreadCrumbsData = {
    PrivacyPolicy: {
        links: [
            {
                title: "מדיניות הפרטיות",
                link: "/privacy-policy"
            }, 
        ]
    },
    TermsOfUse: {
        links: [
            {
                title: "תנאי שימוש",
                link: "/terms-of-use"
            }, 
        ]
    },
    Accessibility: {
        links: [
            {
                title: "הצהרת נגישות",
                link: "/accessibility"
            }, 
        ]
    },
    SiteMap: {
        links: [
            {
                title: "מפת אתר",
                link: "/sitemap"
            }
        ]
    },
    Recall: {
        links: [
            {
                title: "קריאות חוזרות",
                link: "/recall"
            }, 
        ]
    },
    Warranty: {
        links: [
            {
                title: "כתב אחריות",
                link: "/warranty"
            }, 
        ]
    },
    ServiceInstructions: {
        links: [
            {
                title: "הוראות שירות",
                link: "/service-instructions"
            }, 
        ]
    },
    WarrantyExtension: {
        links: [
            {
                title: "בדיקת תכולת הארכת אחריות",
                link: "/warranty-extension"
            }
        ]
    },
    SparePriceList: {
        links: [
            {
                title: "מחירון מוצרי תעבורה",
                link: "/spare-price-list"
            }, 
        ]
    },
    ColorCode: {
        links: [
            {
                title: "קוד צבע",
                link: "/color-code"
            }, 
        ]
    },
    Hamesayat: {
        links: [
            {
                title: "המסייעת",
                link: "/hamesayat"
            }, 
        ]
    },
    VideoTutorials: {
        links: [
            {
                title: "סרטוני הדרכה ותפעול",
                link: "/video-tutorials"
            }, 
        ]
    },
    ServicesCenters: {
        links: [
            {
                title: "מרכזי שירות",
                link: "/services-centers"
            }, 
        ]
    },
    ShowRooms: {
        links: [
            {
                title: "אולמות תצוגה",
                link: "/show-rooms"
            }, 
        ]
    },
    CarList: {
        links: [
            {
                title: "מחירון מכוניות",
                link: "/car-list"
            }, 
        ]
    },
    Insurance: {
        links: [
            {
                title: "ביטוח",
                link: "/insurance"
            }, 
        ]
    },
    CarFleets: {
        links: [
            {
                title: "ציי רכב",
                link: "/car-fleets"
            }, 
        ]
    },
    ContactUs: {
        links: [
            {
                title: "צרו קשר",
                link: "/contact-us"
            }, 
        ]
    },
    ServicePlans: {
        links: [
            {
                title: "תוכנית טיפול",
                link: "/service-plans"
            }, 
        ]
    }
};


// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./common/bit/utils/slugify.ts
var slugify = __webpack_require__(38730);
;// CONCATENATED MODULE: ./common/BreadCrumbs.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        ";\n\n  ",
        " {\n  }\n  ",
        " {\n    position: absolute;\n\n    ",
        ";\n    ",
        ";\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  max-width: 1400px;\n\n  ",
        " {\n    ",
        ";\n    ",
        ";\n    display: flex;\n    justify-content: flex-start;\n    padding-right: 20px;\n  }\n\n  ",
        " {\n    ",
        ";\n    ",
        ";\n  }\n  svg {\n    margin-top: 2px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 10px;\n  font-weight: 300;\n  letter-spacing: normal;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var SINGLE_SERVICE = "singleService";
var CONFIGURATOR = "configurator";
var StyledInnerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BreadCrumbs__StyledInnerWrapper",
    componentId: "sc-e82e91a2-0"
})(_templateObject(), function(p) {
    return p.$page === SINGLE_SERVICE && "top: -20px";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "right: 25px";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$page !== CONFIGURATOR && "right: 50px;";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "top: -10px";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "right: 0px";
});
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BreadCrumbs__StyledWrapper",
    componentId: "sc-e82e91a2-1"
})(_templateObject1(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$page) !== CONFIGURATOR && "width: 100%;";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$page === CONFIGURATOR && "margin-top: -50px";
}, function(p) {
    return p.$page === CONFIGURATOR && (p === null || p === void 0 ? void 0 : p.$pathname) !== constants/* STEPS_EN.summary */.Ws.summary && "margin-right: 50px";
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$page !== CONFIGURATOR && "padding-right: 15px;";
}, function(p) {
    return p.$pathname === constants/* STEPS_EN.color */.Ws.color && "padding-right: 16px";
});
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(NextLink/* default */.Z).withConfig({
    displayName: "BreadCrumbs__StyledLink",
    componentId: "sc-e82e91a2-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.disable;
});
var BreadCrumbsWrapper = function(param) {
    var name = param.name, modelName = param.modelName, id = param.id, page = param.page, pathname = param.pathname;
    var router = (0,client_router.useRouter)();
    var carLinkUrl = function() {
        var carLink = "/model/[modelId]/[modelSlug]".replace("[modelId]", id.toString()).replace("[modelSlug]", (0,slugify/* default */.Z)(modelName));
        return carLink;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        $page: page,
        $pathname: pathname,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInnerWrapper, {
            $page: page,
            children: [
                BreadCrumbsData[name] && !modelName && !id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                    separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsIcon, {}),
                    "aria-label": "מיקומך בדפי האתר",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/",
                            children: "ראשי"
                        }),
                        BreadCrumbsData[name].links.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                color: "inherit",
                                href: item.link,
                                "aria-current": index === BreadCrumbsData[name].links.length - 1 && page !== SINGLE_SERVICE ? "page" : "step",
                                children: item.title
                            }, index);
                        }),
                        page === SINGLE_SERVICE && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: router.asPath,
                            "aria-current": "page",
                            children: router.query.serviceCenterSlug.toString().replace(/-/g, " ")
                        })
                    ]
                }),
                modelName && id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                    separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsIcon, {}),
                    "aria-label": "מיקומך בדפי האתר",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/",
                            children: "ראשי"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/models",
                            children: "לכל הדגמים"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: carLinkUrl(),
                            "aria-current": page !== CONFIGURATOR ? "page" : "step",
                            children: modelName
                        }),
                        page && page === CONFIGURATOR && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: router.asPath,
                            "aria-current": "page",
                            children: "התאמה אישית ורכישה"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var BreadCrumbs = (BreadCrumbsWrapper);


/***/ }),

/***/ 25384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports encodeImageUrl, seoKeys, emptySeo */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12104);




var encodeImageUrl = function(baseUrl, params) {
    // Remove double slashes from the URL path (except for the protocol part)
    var correctedBaseUrl = baseUrl.replace(/([^:]\/)\/+/g, "$1");
    var queryString = Object.keys(params).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
    }).join("&");
    return "".concat(correctedBaseUrl, "?").concat(queryString);
};
var seoKeys = {
};
for(var key in seoKeys){
    seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}
var emptySeo = {
    title: " ",
    description: "",
    keywords: ""
};
var SeoMetaData = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
            title: data.title,
            description: data.description || "",
            additionalMetaTags: [
                {
                    name: "title",
                    content: data.title
                },
                {
                    name: "keywords",
                    content: data.keywords
                },
                {
                    name: "description",
                    content: data.description
                }, 
            ],
            openGraph: {
                title: data.title,
                description: data.description || "",
                images: data.image ? [
                    {
                        url: (0,_createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__/* .createImageApiUrl */ .h)(data.image.imageUrl),
                        alt: data.image.alt,
                        width: 1200,
                        height: 630
                    }, 
                ] : []
            },
            noindex: data.noIndex,
            nofollow: data.noIndex
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SeoMetaData));


/***/ }),

/***/ 95055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var focus_formik_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73192);
/* harmony import */ var focus_formik_error__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(focus_formik_error__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82175);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledForm = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(formik__WEBPACK_IMPORTED_MODULE_3__.Form).withConfig({
    displayName: "FormikForm__StyledForm",
    componentId: "sc-1cd63cac-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
function FormikForm(param) {
    var validationSchema = param.validationSchema, initialValues = param.initialValues, render = param.render, onSubmit = param.onSubmit, innerRef = param.innerRef;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_3__.Formik, {
        innerRef: innerRef,
        initialValues: initialValues,
        validationSchema: validationSchema,
        validateOnBlur: true,
        validateOnChange: true,
        onSubmit: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(values, actions) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            actions.setSubmitting(true);
                            return [
                                4,
                                onSubmit(values, actions)
                            ];
                        case 1:
                            _state.sent();
                            actions.setSubmitting(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(values, actions) {
                return _ref.apply(this, arguments);
            };
        }(),
        children: function(formik) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledForm, {
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(focus_formik_error__WEBPACK_IMPORTED_MODULE_2__.ConnectedFocusError, {}),
                    render(formik)
                ]
            });
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FormikForm);


/***/ }),

/***/ 46363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ required; },
/* harmony export */   "Cr": function() { return /* binding */ schemaCommon; },
/* harmony export */   "Sz": function() { return /* binding */ regex; }
/* harmony export */ });
/* unused harmony exports max, invalid */
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74231);

var max = {
    fullname: [
        50,
        "ניתן להזין עד 50 תווים"
    ]
};
var required = {
    default: "שדה זה הינו שדה חובה",
    firstName: "יש להזין שם פרטי",
    lastName: "יש להזין שם משפחה",
    phoneNumber: "יש להזין מספר טלפון",
    licenseNumber: "יש להזין לוחית רישוי",
    licenceOrChassis: "נא הכנס מספר רישוי או שילדה",
    modelId: "בחר דגם",
    area: "בחר איזור",
    skuOrName: "נא הכנס טקסט חופשי או מספר פריט"
};
var regex = {
    numbersAndLetters: /^[a-zA-Zא-תא-ת0-9 ]+$/,
    numbers: /^[0-9]*$/,
    singleName: /^[a-zA-Zא-ת ״\-,.׳]+$/,
    fullName: /([a-zA-Zא-ת'"\\.-/,].+\s).+/,
    name: /^[A-Za-z\u00C0-\u017F\u0590-\u05fe ,.'-]+$/,
    phoneNumber: /^05\d([-]{0,1})\d{7}$/,
    licenseNumber: /^([0-9]{2}-[0-9]{3}-[0-9]{2}|[0-9]{3}-[0-9]{2}-[0-9]{3}|[0-9]{7,8})$/,
    licenceOrChassis: /^(([0-9]{2}-[0-9]{3}-[0-9]{2}|[0-9]{3}-[0-9]{2}-[0-9]{3}|[0-9]{7,8})|([A-Z]{2}[A-Z0-9]{12}))$/
};
var invalid = {
    numbers: "יש להזין ספרות בלבד",
    numbersShort: "ספרות בלבד",
    numbersAndLetters: "ספרות ואותיות",
    fullName: "שם מלא לא תקין",
    name: "יש להזין אותיות בעברית / אנגלית בלבד",
    email: "כתובת המייל אינה תקינה",
    phoneNumber: "מספר הטלפון אינו תקין",
    licenseNumber: "לוחית רישוי אינה תקינה, נא להזין מספר בעל 7-8 ספרות שמורכב מספרות בלבד",
    licenceOrChassis: "מספר רישוי או שילדה לא תקין"
};
var schemaCommon = {
    phoneNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.phoneNumber, "עד 10 ספרות, ללא מקף").length(10, "עד 10 ספרות, ללא מקף").required("עד 10 ספרות, ללא מקף").max(10, "עד 10 ספרות, ללא מקף"),
    firstName: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.singleName, "רק אותיות בעברית או באנגלית בבקשה").min(2, "יש להזין לפחות שתי אותיות תחת השם").max(50, "יש להזין עד 50 תווים בלבד").required(required.default),
    lastName: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.singleName, "רק אותיות בעברית או באנגלית בבקשה").min(2, "יש להזין לפחות שתי אותיות תחת השם").max(50, "יש להזין עד 50 תווים בלבד").required(required.default),
    fullName: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.fullName, "שם מלא בבקשה :)").max(100, "יש להזין עד 100 תווים בלבד").required(required.default),
    email: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().email("כתובת המייל לא תקינה").required(required.default),
    city: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_(),
    street: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_(),
    apartmentNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.numbers, invalid.numbersShort),
    floorNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.numbers, invalid.numbersShort),
    entranceNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.numbersAndLetters, invalid.numbersAndLetters),
    comments: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().max(200, "ניתן להזין עד 200 תווים"),
    termsOfUseCheckbox: yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7().required("").oneOf([
        true
    ], "יש לאשר את תנאי השימוש"),
    onlyNumbers: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.numbers, invalid.numbersShort),
    organization: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().max(100, "יש להזין עד 100 תווים בלבד"),
    organizationTitle: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().max(100, "יש להזין עד 100 תווים בלבד"),
    checkboxRequired: yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7().required("").oneOf([
        true
    ], "שדה חובה"),
    checkboxNotRequired: yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7().defined(),
    licenseNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("לוחית רישוי אינה תקינה, נא להזין מספר בעל 7-8 ספרות ברצף וללא מקף").matches(regex.licenseNumber, invalid.licenseNumber),
    chassis: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("מספר שילדה אינו תקין"),
    catalog: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required(required.default)
};


/***/ }),

/***/ 12104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ createImageApiUrl; }
/* harmony export */ });
function createImageApiUrl(originalUrl) {
    var baseUrl = "https://www.mazda.co.il";
    var apiUrl = "https://api.mazda.co.il";
    if (!baseUrl || !apiUrl) {
        throw new Error("Environment variables ORIGIN and API_URL must be set");
    }
    // Extract the relative path from the original URL
    var relativePath = originalUrl.replace(apiUrl, "");
    // Construct the API URL
    return "".concat(baseUrl, "/api/ogimage").concat(encodeURI(relativePath));
}


/***/ }),

/***/ 7399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ initialFormStatesCarFleet; }
/* harmony export */ });
/* harmony import */ var common_bit_form_FormikSchema__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46363);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74231);


var schemaCarFleet = yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry({
    subject: yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_().required("שדה חובה"),
    firstName: common_bit_form_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.firstName */ .Cr.firstName,
    lastName: common_bit_form_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.lastName */ .Cr.lastName,
    email: common_bit_form_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.email */ .Cr.email,
    phoneNumber: common_bit_form_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.phoneNumber */ .Cr.phoneNumber,
    organization: common_bit_form_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.organization */ .Cr.organization,
    organizationTitle: common_bit_form_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.organizationTitle */ .Cr.organizationTitle,
    approveMailingList: common_bit_form_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.checkboxNotRequired */ .Cr.checkboxNotRequired,
    message: yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_().max(500, "יש להזין עד 500 תווים בלבד")
}).defined();
var initialFormStatesCarFleet = {
    subject: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    message: "",
    organization: "",
    organizationTitle: "",
    approveMailingList: false
};
/* harmony default export */ __webpack_exports__["Z"] = (schemaCarFleet);


/***/ }),

/***/ 83225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ formsComp_FormSelect; },
  "L": function() { return /* binding */ toFormSelectOptions; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputLabel/InputLabel.js + 1 modules
var InputLabel = __webpack_require__(85161);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(37702);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/formik-material-ui/dist/formik-material-ui.es6.js + 4 modules
var formik_material_ui_es6 = __webpack_require__(24065);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./common/bit/form/FormikSelect.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    .MuiSelect-root {\n      &:focus-visible {\n        border: 2px dashed white;\n        outline: 3px dashed #0e3487;\n        outline-offset: 2px;\n      }\n    }\n\n    ",
        "\n    width: 100%;\n    .MuiFormHelperText-contained {\n      margin-right: 0;\n    }\n    .MuiFormHelperText-root {\n      font-size: 12px;\n    }\n    /* text alignment: */\n    .MuiSelect-outlined.MuiSelect-outlined {\n      text-align: initial;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Styled = {
    Field: (0,styled_components_browser_esm/* default */.ZP)(formik_esm.Field).withConfig({
        displayName: "FormikSelect__Field",
        componentId: "sc-fb0e1fb7-0"
    })(_templateObject(), function(p) {
        return (p === null || p === void 0 ? void 0 : p.$hiddenLabel) && "label { display: none; }";
    })
};
function FormikSelect(_param) {
    var name = _param.name, label = _param.label, _required = _param.required, required = _required === void 0 ? false : _required, selectValues = _param.selectValues, map = _param.map, placeholder = _param.placeholder, hiddenLabel = _param.hiddenLabel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "required",
        "selectValues",
        "map",
        "placeholder",
        "hiddenLabel"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled.Field, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        component: formik_material_ui_es6/* TextField */.nv,
        select: true,
        name: name,
        id: name,
        required: required,
        label: label,
        helperText: " ",
        $hiddenLabel: hiddenLabel,
        placeholder: placeholder
    }, props), {
        children: selectValues === null || selectValues === void 0 ? void 0 : selectValues.map(function(value, i) {
            var ref = map(value), name = ref.name, id = ref.id;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                value: id,
                children: name
            }, i);
        })
    }));
}
/* harmony default export */ var form_FormikSelect = (FormikSelect);

;// CONCATENATED MODULE: ./reusable/formsComp/FormSelect.tsx



function FormSelect_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    FormSelect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transform: none !important;\n    font-size: 16px;\n    color: ",
        ";\n    font-weight: 400;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: start;\n    font-size: 12px;\n    margin-top: -23px;\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var FormSelect_Styled = {
    FormControl: (0,styled_components_browser_esm/* default */.ZP)(FormControl/* default */.Z).withConfig({
        displayName: "FormSelect__FormControl",
        componentId: "sc-8af10bf7-0"
    })(FormSelect_templateObject()),
    FieldWrapper: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        displayName: "FormSelect__FieldWrapper",
        componentId: "sc-8af10bf7-1"
    })(_templateObject1(), function(p) {
        if ((p === null || p === void 0 ? void 0 : p.$marginTop) === 0) return "0px";
        if (p === null || p === void 0 ? void 0 : p.$marginTop) return p.$marginTop + "px";
        return "22px";
    }),
    InputLabel: (0,styled_components_browser_esm/* default */.ZP)(InputLabel/* default */.Z).withConfig({
        displayName: "FormSelect__InputLabel",
        componentId: "sc-8af10bf7-2"
    })(_templateObject2(), function(p) {
        return p.theme.colors.darkGrey;
    }),
    BottomText: (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
        variant: "body1"
    }).withConfig({
        displayName: "FormSelect__BottomText",
        componentId: "sc-8af10bf7-3"
    })(_templateObject3(), function(p) {
        return p.theme.colors.marbleGrey;
    })
};
var toFormSelectOptions = function(list, idProp, nameProp) {
    return list.map(function(item) {
        return {
            id: item[idProp],
            name: item[nameProp]
        };
    });
};
function FormSelect(_param) {
    var name = _param.name, label = _param.label, _required = _param.required, required = _required === void 0 ? false : _required, values = _param.values, // bottomText,
    map = _param.map, placeholder = _param.placeholder, hiddenLabel = _param.hiddenLabel, marginTop = _param.marginTop, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "required",
        "values",
        "map",
        "placeholder",
        "hiddenLabel",
        "marginTop"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect_Styled.FieldWrapper, {
            $marginTop: marginTop,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_FormikSelect, (0,_object_spread/* default */.Z)({
                label: label,
                name: name,
                required: required,
                selectValues: values,
                hiddenLabel: hiddenLabel,
                map: map,
                placeholder: placeholder
            }, props))
        })
    });
}
/* harmony default export */ var formsComp_FormSelect = (FormSelect);


/***/ }),

/***/ 63358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13328);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  position: relative;\n  height: 150px;\n  ",
        " {\n    height: 270px;\n    ",
        ";\n  }\n  img {\n    object-fit: cover;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ImageContainer__StyledImageContainer",
    componentId: "sc-4c5af28c-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$collapseOpen && "margin-top: 63px";
});
var ImageContainer = function(param) {
    var src = param.src;
    var collapseOpen = (0,store__WEBPACK_IMPORTED_MODULE_3__/* .useTypedSelector */ .ix)(function(state) {
        return state.collapseLayout;
    }).collapseOpen;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImageContainer, {
        $collapseOpen: collapseOpen,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            src: src,
            layout: "fill",
            priority: true,
            alt: "page-cover-img",
            role: "presentation",
            "aria-hidden": "true"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageContainer);


/***/ }),

/***/ 45732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43832);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var common_BreadCrumbs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15738);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6089);
/* harmony import */ var _ImageContainer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63358);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  padding-top: ",
        "px;\n  flex-direction: column;\n  background-color: ",
        ";\n  ",
        " {\n    padding-top: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-bottom: 60px;\n  flex-direction: column;\n  width: 100%;\n  padding-right: 20px;\n  padding-left: 20px;\n  ",
        " {\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 80px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 40px 20px;\n  padding-bottom: ",
        ";\n  ",
        " {\n    padding: 40px 20px 20px;\n    max-width: 800px;\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: right;\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: right;\n  margin-top: 10px;\n  ",
        " {\n    margin-top: 20px;\n    text-align: center;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var StyledPageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "InnerPageWrapper__StyledPageWrapper",
    componentId: "sc-df466e4e-0"
})(_templateObject(), theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .HEADER_HEIGHT_M */ .Gi, function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .HEADER_HEIGHT_D */ .gw);
var StyledPageWrap = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "InnerPageWrapper__StyledPageWrap",
    componentId: "sc-df466e4e-1"
})(_templateObject1());
var StyledContentWrap = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "InnerPageWrapper__StyledContentWrap",
    componentId: "sc-df466e4e-2"
})(_templateObject2(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "InnerPageWrapper__StyledHeader",
    componentId: "sc-df466e4e-3"
})(_templateObject3(), function(p) {
    return "".concat(p.$paddingBottom && p.$paddingBottom, "px");
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return "".concat(p.$paddingBottom && p.$paddingBottom, "px !important");
});
var StyledHeadline = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).attrs({
    variant: "h2",
    component: "h1"
}).withConfig({
    displayName: "InnerPageWrapper__StyledHeadline",
    componentId: "sc-df466e4e-4"
})(_templateObject4(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    displayName: "InnerPageWrapper__StyledSubtitle",
    componentId: "sc-df466e4e-5"
})(_templateObject5(), function(p) {
    return p.theme.breakpoints.up("md");
});
var InnerPageWrapper = function(param) {
    var imgUrl = param.imgUrl, title = param.title, subtitle = param.subtitle, children = param.children, breadCrumbName = param.breadCrumbName, page = param.page, paddingBottom = param.paddingBottom, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPageWrapper, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledPageWrap, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ImageContainer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    src: imgUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(common_BreadCrumbs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    name: breadCrumbName,
                    page: page
                }),
                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledHeader, {
                    $paddingBottom: paddingBottom,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledHeadline, {
                            children: [
                                " ",
                                title,
                                " "
                            ]
                        }),
                        subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSubtitle, {
                            dangerouslySetInnerHTML: {
                                __html: subtitle
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContentWrap, {
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InnerPageWrapper);


/***/ }),

/***/ 61503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ service_plans; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(25384);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./common/bit/form/FormikForm.tsx
var FormikForm = __webpack_require__(95055);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./reusable/formsComp/FormSelect.tsx + 1 modules
var FormSelect = __webpack_require__(83225);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./reusable/wrappers/InnerPageWrapper.tsx
var InnerPageWrapper = __webpack_require__(45732);
// EXTERNAL MODULE: ./components/pages/carFleet/SchemaCarFleet.ts
var SchemaCarFleet = __webpack_require__(7399);
;// CONCATENATED MODULE: ./components/pages/ServicePlans/ServicePlansPage.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 1100px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  margin-bottom: 20px;\n  text-align: right;\n  ",
        " {\n    margin-bottom: 40px;\n    text-align: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 680px;\n  max-width: 100%;\n  margin: 0px auto;\n  display: flex;\n  justify-content: center;\n  gap: 40px;\n  ",
        " {\n    flex-direction: column;\n    gap: 0px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-top: 20px;\n  justify-content: center;\n  ",
        " {\n    justify-content: flex-start;\n    margin-top: 25px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  color: ",
        ";\n  width: 296px;\n  height: 45px;\n  transition: 200ms all ease;\n  border: none;\n  :hover {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 680px;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  margin: 40px 0 0;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 8px;\n  align-items: center;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: underline;\n  word-break: break-all;\n  font-size: 16px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 1px;\n  background-color: ",
        ";\n  margin-top: 0;\n  margin-bottom: 40px;\n  opacity: 0.5;\n  ",
        " {\n    margin-top: 20px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 60px;\n  width: 680px;\n  max-width: 100%;\n  margin-bottom: 40px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: right;\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  unicode-bidi: plaintext;\n  font-size: 16px;\n  display: block;\n  padding: 5px 0;\n  text-decoration: underline;\n  text-align: right;\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  margin-top: 20px;\n  text-align: right;\n  font-weight: 300;\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}











var StyledInnerPageWrapper = (0,styled_components_browser_esm/* default */.ZP)(InnerPageWrapper/* default */.Z).withConfig({
    displayName: "ServicePlansPage__StyledInnerPageWrapper",
    componentId: "sc-4f8958de-0"
})(_templateObject());
var StyledHeadlineText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).withConfig({
    displayName: "ServicePlansPage__StyledHeadlineText",
    componentId: "sc-4f8958de-1"
})(_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledFormSelectWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ServicePlansPage__StyledFormSelectWrapper",
    componentId: "sc-4f8958de-2"
})(_templateObject2(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledBtnWrapp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ServicePlansPage__StyledBtnWrapp",
    componentId: "sc-4f8958de-3"
})(_templateObject3(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledBtn = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "ServicePlansPage__StyledBtn",
    componentId: "sc-4f8958de-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.headerColor;
}, function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.colors.darkBlack;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledResultsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ServicePlansPage__StyledResultsWrapper",
    componentId: "sc-4f8958de-5"
})(_templateObject5());
var StyledNextLink = (0,styled_components_browser_esm/* default */.ZP)(NextLink/* default */.Z).withConfig({
    displayName: "ServicePlansPage__StyledNextLink",
    componentId: "sc-4f8958de-6"
})(_templateObject6());
var StyledFileName = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).withConfig({
    displayName: "ServicePlansPage__StyledFileName",
    componentId: "sc-4f8958de-7"
})(_templateObject7());
var StyledDivider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ServicePlansPage__StyledDivider",
    componentId: "sc-4f8958de-8"
})(_templateObject8(), function(p) {
    return p.theme.colors.darkGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledDisclaimerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ServicePlansPage__StyledDisclaimerWrapper",
    componentId: "sc-4f8958de-9"
})(_templateObject9());
var StyledHeadline = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "h2",
    component: "h2"
}).withConfig({
    displayName: "ServicePlansPage__StyledHeadline",
    componentId: "sc-4f8958de-10"
})(_templateObject10(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledPhoneLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "ServicePlansPage__StyledPhoneLink",
    componentId: "sc-4f8958de-11"
})(_templateObject11(), function(p) {
    return p.theme.colors.saphire;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledDisclaimer = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).withConfig({
    displayName: "ServicePlansPage__StyledDisclaimer",
    componentId: "sc-4f8958de-12"
})(_templateObject12(), function(p) {
    return p.theme.breakpoints.up("md");
});
var ServicePlansPage = function(param) {
    var data = param.data;
    var ref = (0,react.useState)(null), selectedModel = ref[0], setSelectedModel = ref[1];
    var ref1 = (0,react.useState)(null), selectedDisplayName = ref1[0], setSelectedDisplayName = ref1[1];
    var ref2 = (0,react.useState)(null), pdf = ref2[0], setPdf = ref2[1];
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var modelsList = data.modelList.sort(function(a, b) {
        return a.modelName.localeCompare(b.modelName);
    });
    var updateDate = new Date(data.lastUpdateDate || undefined).toLocaleDateString("en-GB");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInnerPageWrapper, {
        title: "תוכנית טיפול מותאמת לרכב שלך",
        subtitle: "תוכנית הטיפול מציגה את רשימת החלקים שיש להחליף במעמד טיפול לרכבך.<br/> הטיפול נדרש לביצוע באחד המקרים הבאים, המוקדם מבניהם: כשמופיעה התראה בלוח המחוונים של רכבך / לאחר נסיעה של 15,000 ק״מ / במידה וחלפה שנה ממועד הטיפול הקודם.",
        imgUrl: isDesktop ? "/img/cover/tutorialvideos.jpg" : "/img/cover/tutorialvideosmobile.jpg",
        breadCrumbName: "ServicePlans",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDivider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadlineText, {
                children: "להצגת תוכנית הטיפול, יש לבחור את דגם הרכב ושנת העלייה לכביש (מידע זה נמצא ברישיון הרכב)."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikForm/* default */.Z, {
                validationSchema: SchemaCarFleet/* default */.Z,
                initialValues: SchemaCarFleet/* initialFormStatesCarFleet */.I,
                onSubmit: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        if (!selectedDisplayName) return [
                            2
                        ];
                        setPdf(selectedDisplayName.pdf);
                        return [
                            2
                        ];
                    });
                }),
                render: function() {
                    var ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFormSelectWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect/* default */.Z, {
                                        id: "modelSelect",
                                        name: "select",
                                        color: "primary",
                                        label: "דגם הרכב",
                                        values: modelsList.map(function(item) {
                                            return item.modelName;
                                        }),
                                        map: function(item) {
                                            return {
                                                id: item,
                                                name: item
                                            };
                                        },
                                        onChange: function(e) {
                                            setSelectedModel(modelsList.find(function(m) {
                                                var ref;
                                                return m.modelName === (e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                            }));
                                        },
                                        // focused
                                        value: selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.modelName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect/* default */.Z, {
                                        id: "DisplayNameSelect",
                                        name: "displaySelect",
                                        color: "primary",
                                        label: "שנת עלייה לכביש",
                                        values: (0,_to_consumable_array/* default */.Z)(new Set(selectedModel === null || selectedModel === void 0 ? void 0 : (ref = selectedModel.displayList) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                                            return item.displayName;
                                        }))),
                                        map: function(item) {
                                            return {
                                                id: item,
                                                name: item
                                            };
                                        },
                                        onChange: function(e) {
                                            setSelectedDisplayName(selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.displayList.find(function(m) {
                                                var ref;
                                                return m.displayName === (e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                            }));
                                        },
                                        disabled: !selectedModel,
                                        value: selectedDisplayName === null || selectedDisplayName === void 0 ? void 0 : selectedDisplayName.displayName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBtnWrapp, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBtn, {
                                    disabled: !selectedDisplayName,
                                    onClick: function() {
                                        if (!selectedDisplayName) return;
                                        setPdf(selectedDisplayName.pdf);
                                    },
                                    children: "להצגת תוכנית הטיפול שלי"
                                })
                            })
                        ]
                    });
                }
            }),
            pdf && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledResultsWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h3",
                        component: "h2",
                        children: "תוצאות חיפוש:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNextLink, {
                        openInNewTab: true,
                        href: pdf.url,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/img/filePdf.svg",
                                width: 32,
                                height: 32,
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFileName, {
                                children: [
                                    pdf.fileName,
                                    ".pdf"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDisclaimerWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadline, {
                        children: "שירות הלקוחות שלנו זמין בשבילך לכל עניין:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPhoneLink, {
                        href: "tel:*2880",
                        children: "*2880"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDisclaimer, {
                        children: [
                            "המידע המוצג נכון לתאריך ",
                            updateDate,
                            " וייתכנו בו שינויים מעת לעת בהתאם להנחיית היצרן, תכנית הטיפולים עשויה להיות מושפעת ממאפייני הנהיגה, תנאי הדרך, האקלים, תחזוקת הרכב, קריאת מפתח הרכב ועוד. יתכן ויידרשו פעולות נוספות בהתאם לתוצאות הבדיקה ומצב הרכב"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ServicePlans_ServicePlansPage = (ServicePlansPage);

;// CONCATENATED MODULE: ./src/pages/service-plans.tsx



var ServicePlans = function(param) {
    var pageData = param.pageData, seo = param.seo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicePlans_ServicePlansPage, {
                data: pageData
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var service_plans = (ServicePlans);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4245,2669,2968,9774,2888,179], function() { return __webpack_exec__(51942); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);